export const PlusIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={14}
        height={14}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M12.833 6.167h-5v-5a.834.834 0 0 0-1.666 0v5h-5a.834.834 0 0 0 0 1.666h5v5a.834.834 0 0 0 1.666 0v-5h5a.834.834 0 0 0 0-1.666Z"
        />
    </svg>
)